module.exports = __webpack_public_path__ + "img/ncr.5097fc17.svg";